import { ThemeProvider } from '@smartgift/frontend-toolkit';
import get from 'lodash/get';
import merge from 'lodash/merge';
import React from 'react';

import { AppLoader } from '@hero/atoms';
import { configs } from '@hero/configs';
import * as constants from '@hero/constants';
import { useGetTheme } from '@hero/services/cdn-service/hooks';
import { useGetPublicEntities } from '@hero/services/merchant-service/hooks';

import { theme as defaultTheme } from './theme';

const definitions = {
  configs,
  constants
};

const prepareDataForThemeProvider = props => {
  Object.keys(props?.images || []).forEach(imageKey => {
    const originalImage = props.images[imageKey];
    const updatedImage = originalImage.replace(
      new RegExp('{{(.+?)}}'),
      function (_c, definitionPath) {
        return get(definitions, definitionPath);
      }
    );
    props.images[imageKey] = updatedImage;
  });

  return props;
};

export const BootstrapProvider = ({ children, theme = {} }) => {
  const { data: publicEntitiesData = {}, isLoading: isLoadingWidgets } = useGetPublicEntities({
    params: {
      filters: {
        type: 'config',
        merchantCode: configs.merchantName
      }
    }
  });
  const { data: themeData = {}, isLoading: isThemeLoading } = useGetTheme();
  const mergedOne = merge(defaultTheme, themeData);
  const mergedTwo = merge(mergedOne, {
    widgets: publicEntitiesData?.widgets,
    typography: publicEntitiesData?.typography,
    images: publicEntitiesData?.images,
    publicUrl: configs.publicUrl
  });
  const mergedThree = merge(mergedTwo, theme);
  const mergedFour = merge(mergedThree, { variables: publicEntitiesData.variables });

  return (
    <ThemeProvider theme={prepareDataForThemeProvider(mergedFour)}>
      {isThemeLoading || isLoadingWidgets ? <AppLoader hasLogos={false} /> : children}
    </ThemeProvider>
  );
};
